const optionsFuelType = [
    { label: "Select", value: "", key: 0 },
    { label: "Petrol", value: "Petrol", key: 1 },
    { label: "Diesel", value: "Diesel", key: 2 },
    { label: "Gas", value: "Gas", key: 3 },
    { label: "Other", value: "Other", key: 4 }
  ];

  export default optionsFuelType;
  